
const RESET_SELECTOR = '.reset-on-search';

function isFormElement(el: Element): el is HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement {
  return el instanceof HTMLInputElement || el instanceof HTMLSelectElement || el instanceof HTMLTextAreaElement;
}

function clearResettableInputs(scope: ParentNode, queryInput: Element): void {
  const elems = Array.from(scope.querySelectorAll(RESET_SELECTOR));

  for (const el of elems) {
    console.log(el);
    if (el === queryInput) continue;

    if (isFormElement(el)) {
      clearElement(el);
    } else {
      // If the resettable selector is applied to a container, clear its form controls
      const inner = Array.from(el.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>('input, select, textarea'));
      for (const control of inner) {
        if (control === queryInput) continue;
        clearElement(control);
      }
    }
  }
}

function clearElement(el: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement): void {
  if (el instanceof HTMLInputElement) {
    const t = el.type?.toLowerCase();
    if (t === 'checkbox' || t === 'radio') {
      el.checked = false;
    } else {
      el.value = '';
    }
  } else if (el instanceof HTMLSelectElement) {
    // prefer clearing the value; for single select this will choose empty option if present
    try {
      el.value = '';
    } catch {
      el.selectedIndex = -1;
    }
  } else {
    el.value = '';
  }

  el.dispatchEvent(new Event('input', { bubbles: true }));
  el.dispatchEvent(new Event('change', { bubbles: true }));
}

const searchSelector = '.search-trigger';
const searchInputs = Array.from(document.querySelectorAll<HTMLInputElement>(searchSelector));

for (const queryInput of searchInputs) {
  console.log('Initializing search input:', queryInput);
  const form = queryInput.closest('form') as HTMLFormElement | null;
  console.log('Found form for search input:', form);

  if (form) {
    form.addEventListener('submit', () => {
      clearResettableInputs(form, queryInput);
    });
  }

  // HTML5 'search' event fires when the native clear button is used in some browsers
  queryInput.addEventListener('search', (e: Event) => {
    const target = e.target as HTMLInputElement;
    if (target.value === '') {
      clearResettableInputs(form ?? document, queryInput);
    }
  });
}

